import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";

/**
 * @property {Help_Desks_Object} state
 * @property {object} model
 * @property {Help_Desks_Properties} model.properties
 *
 */

class HelpDeskAdd extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Help_Desks._name);
		this.state.filterDate = 0;
	}

	handleDateUpdate = (property, value) => {
		this.setState({filterDate: Date.parse(value)})
	}

	form = () => {
		/**
		 * @param {Help_Desks_Properties} data
		 */
		let {properties} = this.model;

		/**
		 * @type {Help_Desks_Object} object
		 */
		let object = this.state;
		return (
			<fieldset>
				<div className={'row'}>
					<div className={'col-4'}>
						<div className="form-group">
							<Framework.Elements.ButtonSwitch
								property={properties.hasTicket}
								value={object.hasTicket}
								error={object.hasTicket_error}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={'Ticket'}
								labelFalse={'No ticket'}
							/>
						</div>
					</div>
					<div className={'col-4'}>
						{object.hasTicket &&
						<Framework.Elements.Date
							label={"Appointment Date"}
							value={this.state.filterDate === 0 ? Date.now() : this.state.filterDate}
							update={this.handleDateUpdate}
						/>}
					</div>
					<div className={'col-4'}>
						{object.hasTicket &&
						<div className="form-group">
							<Framework.Elements.Select
								objectKey={this.state.filterDate.toString()}
								shouldLoad={this.state.hasTicket}
								update={this.handleSelectPropertyUpdate}
								property={properties.ticket}
								value={object.ticket}
								error={object.ticket_error}
								object={object.tickets}
								nullable={false}
								limit={null}
								requestOverride={'GET_FE_TICKETS'}
								parent={this.props.rootState.user}
								text={'pkey'}
								filter={(data) => {
									if (Date.parse(data.appointment_start) >= (this.state.filterDate))
									{
										return data
									}
								}}
							/>
						</div>}
					</div>
				</div>
				<div className={'row'}>
					<div className={'col-12'}>
						<div className="form-group">
							<Framework.Elements.TextField
								property={properties.notes}
								value={object.notes}
								error={object.notes_error}
								update={this.handleTextFieldPropertyUpdate}
								multiline={4}
							/>
						</div>
					</div>
				</div>
			</fieldset>
		)
	}
}

export default Framework.Components.withRootState(HelpDeskAdd);